import { render } from "./AddOwnershipAddress.vue?vue&type=template&id=0a46149d&scoped=true"
import script from "./AddOwnershipAddress.vue?vue&type=script&lang=js"
export * from "./AddOwnershipAddress.vue?vue&type=script&lang=js"

import "./AddOwnershipAddress.vue?vue&type=style&index=0&id=0a46149d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a46149d"]])

export default __exports__